import { reqGetGeneralSetting, reqGetQueues } from "@/api/api.js";

const state = {
  baseUrl: "",
  queues: [],
};
const mutations = {
  GETGENERALSETTINGBASEURL(state, baseUrl) {
    state.baseUrl = baseUrl;
  },
  GETQUEUES(state, queues) {
    state.queues = queues;
  },
};
const actions = {
  async getGeneralSetting({ commit }, data) {
    let result = await reqGetGeneralSetting(data);
    if (result.status === 200) {
      commit("GETGENERALSETTINGBASEURL", result.data.jsonValue.baseUrl);
    }
  },
  async getQueues({ commit }, data) {
    let result = await reqGetQueues(data);
    if (result.status === 200) {
      commit("GETQUEUES", result.data.data);
    }
  },
};
const getters = {
  queues(state) {
    for (let i = 0; i < state.queues.length; i++) {
      const submitStrategyType = state.queues[i].submitStrategy.type;
      if (submitStrategyType === "SEQUENTIAL_BY_ORIGINATOR") {
        state.queues[i].submitStrategy.submitType = "按发起者顺序处理";
      } else if (submitStrategyType === "BURST") {
        state.queues[i].submitStrategy.submitType = "突发处理";
      } else {
        state.queues[i].submitStrategy.submitType = "";
      }
      const processingStrategyType = state.queues[i].processingStrategy.type;
      if (processingStrategyType === "RETRY_FAILED_AND_TIMED_OUT") {
        state.queues[i].processingStrategy.processingType = "失败与超时重试";
      } else if (processingStrategyType === "SKIP_ALL_FAILURES") {
        state.queues[i].processingStrategy.processingType = "跳过所有失败";
      } else {
        state.queues[i].processingStrategy.processingType = "";
      }
    }
    return state.queues || [];
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
